import { render } from "./WebshopPaymentSelector.vue?vue&type=template&id=c23ea97a"
import script from "./WebshopPaymentSelector.vue?vue&type=script&lang=js"
export * from "./WebshopPaymentSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__